import request from '@/utils/request'
import qs from 'qs'
/* 根据用户屏登录 */
export function loginByUsername(orgCode, username, password) {
  var postData = {}
  postData.username = username
  postData.password = password
  postData.orgCode = orgCode
  return request({
    url: '/login',
    method: 'post',
    data: qs.stringify(postData)
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: '/getUserInfo',
    method: 'post'
  })
}

export function saveUserMenu(data) {
  var postData = {}
  postData.userMenus = data.join(',')
  return request({
    url: '/saveUserMenu',
    method: 'post',
    data: qs.stringify(postData)
  })
}

export function validatePassword(data) {
  return request({
    url: '/validatePassword',
    method: 'post',
    data: qs.stringify(data)
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js